import React from 'react';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import SearchBarB from 'components/SearchBar/SearchBarB';
import SearchButtonBase from '../SearchButtonBase';
import classes from './SearchButtonA.module.scss';

const SearchButtonA = (props) => {
  const [showSearch, setShowSearch] = React.useState(false);

  const onClick = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
  };

  const renderSearchBox = (inputText) => {
    const classObj = {
      [classes.invisibleBox]: !showSearch,
      [classes.visibleBox]: showSearch,
    };

    return (
      <div className={classNames(classes.searchBar, classObj)}>
        <SearchBarB {...props} inputText={inputText} />
        <button
          className={classes.closeButton}
          onClick={() => setShowSearch(false)}
          aria-label='Close'
          type='button'
        >
          <FontIcon icon='far fa-times' />
        </button>
      </div>
    );
  };

  return (
    <SearchButtonBase
      {...props}
      searchButtonIcon='far fa-search'
      classes={classes}
      renderSearchBox={renderSearchBox}
      onClick={onClick}
    />
  );
};

export default SearchButtonA;
